<script setup>
import VDevider from "@/Shared/VDevider.vue";

import { DEPARTING_ENUM } from "../tabs.config";
import VShowTravelArrangement from "../../../../Shared/Survey/Departing/VShowTravelArrangement.vue";
import VShowExpense from "../../../../Shared/Survey/Departing/VShowExpense.vue";
import VShowVacation from "../../../../Shared/Survey/Departing/VShowVacation.vue";
import VShowFeedbacks from "../../../../Shared/Survey/Departing/VShowFeedbacks.vue";
import { computed, ref, watch } from "vue";
import VShowDemographic from "../../../../Shared/Survey/Departing/VShowDemographic.vue";
import VShowTravel from "../../../../Shared/Survey/Departing/VShowTravel.vue";
import VShowEntryPoint from "../../../../Shared/Survey/Departing/VShowEntryPoint.vue";
import VShowAirEntryPoint from "../../../../Shared/Survey/Departing/VShowAirEntryPoint.vue";

const props = defineProps({
    tab: Object,
    surveyFields: Object,
    answers: Object,
});

const emits = defineEmits(["onNext", "onPrev"]);
const form = ref({});

watch(
    () => props.tab?.key,
    (value) => {
        if (
            value == DEPARTING_ENUM.FORM_4 &&
            "By Air" !=
                form.value
                    ?.which_of_the_following_entry_point_did_you_go_through_to_enter_sabah
        ) {
            emits("onNext", { ...form.value });
        }
    }
);

const activeComponent = computed({
    get() {
        switch (props.tab.key) {
            case DEPARTING_ENUM.FORM_1:
                return {
                    component: VShowDemographic,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case DEPARTING_ENUM.FORM_2:
                return {
                    component: VShowTravel,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case DEPARTING_ENUM.FORM_3:
                return {
                    component: VShowEntryPoint,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case DEPARTING_ENUM.FORM_4:
                return {
                    component: VShowAirEntryPoint,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case DEPARTING_ENUM.FORM_5:
                return {
                    component: VShowTravelArrangement,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case DEPARTING_ENUM.FORM_6:
                return {
                    component: VShowExpense,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case DEPARTING_ENUM.FORM_7:
                return {
                    component: VShowVacation,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case DEPARTING_ENUM.FORM_8:
                return {
                    component: VShowFeedbacks,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
        }
    },
});

const handelOnNext = (data) => {
    for (let props in data) {
        form.value[props] = data[props];
    }

    emits("onNext", { ...form.value });
};
</script>

<template>
    <div class="row">
        <div class="col-12">
            <h5>{{ tab.title }}</h5>
            <VDevider class="mb-4" />
            <KeepAlive>
                <component
                    :is="activeComponent.component"
                    :additional="activeComponent.additional"
                    @onNext="handelOnNext"
                    @onPrev="emits('onPrev')"
                />
            </KeepAlive>
        </div>
    </div>
</template>
